import { render, staticRenderFns } from "./MyAssessment.vue?vue&type=template&id=006d638c&scoped=true&"
import script from "./MyAssessment.vue?vue&type=script&lang=js&"
export * from "./MyAssessment.vue?vue&type=script&lang=js&"
import style0 from "./MyAssessment.vue?vue&type=style&index=0&id=006d638c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006d638c",
  null
  
)

export default component.exports